/* HURRICANE theme — assets/js/home.js. Generated by _build/theme/pack.mjs from the static site's own JS. */
(function () {
'use strict';
var W = window, d = document, HRC = W.HRC, $ = HRC.$, $$ = HRC.$$;
var mm = function (q) { try { return W.matchMedia(q).matches; } catch (e) { return false; } };
var DESK = '(min-width: 900px) and (orientation: landscape)';
(function () {
var hero = $('[data-hero]'), v = $('[data-hero-video]');
if (!hero || !v) return;
var frame = $('[data-hero-frame]', hero), copy = $('[data-hero-copy]', hero), hint = $('[data-hint="scroll"]', hero);
function src() {
if (mm('(min-width: 600px)')) return v.getAttribute('data-f1080');
var big = (W.devicePixelRatio || 1) >= 3 && !HRC.saveData && !HRC.slowNet;
return v.getAttribute(big ? 'data-m1080' : 'data-m720');
}
HRC.afterPaint(function () {
var open = false;
var c = HRC.clip(v, { probe: true, src: src, observe: hero, threshold: 0.05, hold: function () { return !open; },
onPlaying: function () { frame.classList.add('playing'); }, onFail: function () { frame.classList.remove('playing'); } });
HRC.doorOpen(function () { open = true; if (c) c.play(); });
});
var bar = $$('[data-hero-beats] i', hero), starts = (hero.getAttribute('data-beats') || '').split(',').map(Number), lit = -1;
function beats() {
var t = v.currentTime, k = 0;
for (var i = 0; i < starts.length; i++) if (t >= starts[i] - 0.05) k = i;
if (k === lit) return;
lit = k;
bar.forEach(function (b, i) { b.classList.toggle('on', i <= k); });
}
v.addEventListener('timeupdate', beats);
v.addEventListener('seeked', beats);
var chip = $('[data-hero-chip]', hero);
var spans = chip ? (chip.getAttribute('data-spans') || '').split(',').filter(Boolean).map(function (s) { var x = s.split('-'); return [+x[0], +x[1]]; }) : [];
function chipSync() {
if (!chip) return;
var t = v.currentTime, film = frame.classList.contains('playing') && !v.paused;
chip.classList.toggle('on', !film || spans.some(function (s) { return t >= s[0] && t < s[1]; }));
}
['timeupdate', 'seeked', 'playing', 'pause'].forEach(function (e) { v.addEventListener(e, chipSync); });
var kick = $('.hero__k', copy);
function scrimAt() {
if (!kick || mm('(min-width: 600px) and (orientation: landscape)') || !frame.offsetHeight) { frame.style.removeProperty('--sy'); return; }
frame.style.setProperty('--sy', (100 * (copy.offsetTop + kick.offsetTop - frame.offsetTop) / frame.offsetHeight).toFixed(1) + '%');
}
scrimAt();
if (d.fonts && d.fonts.ready) d.fonts.ready.then(scrimAt);
W.addEventListener('resize', scrimAt);
var still = function () { return HRC.RM || HRC.paused || HRC.motionMode === 'still'; };
var last = '';
function draw() {
var vh = W.innerHeight || 1, y = Math.max(0, W.scrollY || W.pageYOffset || 0);   // the hero opens the page
var hp = still() ? 0 : Math.min(1, y / (0.18 * vh));
var q = still() ? 0 : Math.min(1, Math.max(0, (y - 0.2 * vh) / (0.6 * vh)));
var key = hp.toFixed(3) + '|' + q.toFixed(3);
if (key === last) return;
last = key;
hero.style.setProperty('--hp', hp.toFixed(3));
frame.style.setProperty('--hs', (1 - 0.05 * q).toFixed(4));
frame.style.setProperty('--hr', (16 * q).toFixed(1) + 'px');
if (y > 0 && hint && hint.classList.contains('show')) HRC.hintUsed('scroll');
}
HRC.onScroll(draw);
HRC.on('motion', function () { last = ''; draw(); });
HRC.on('motionmode', function () { last = ''; draw(); });
draw();
})();
(function () {
var ride = $('[data-ride]');
if (!ride) return;
var cv = $('[data-ride-cv]', ride), g = cv.getContext('2d', { alpha: false }), pin = $('.ride__pin', ride);
var caps = $$('[data-cap]', ride), prog = $('[data-ride-prog]', ride), fline = $('[data-ride-fl]', ride);
var cards = { A: $('[data-ride-card="a"]', ride), B: $('[data-ride-card="b"]', ride) };
var HOLD_A = 0.5, FLIGHT = 1.6, HOLD_B = 0.25, RUN = HOLD_A + FLIGHT + HOLD_B;
var CAPS = [0, 0.366, 0.73];                      // v7's caption switches (0.42 / 0.72 of its section), on the flight
var OMEGA = 18;                                   // the follower: critically damped, 63 % in ~0.12 s
var EASE = 0.35;                                  // the share of smoothstep in the scroll → path map (ends ease)
var MAG_LO = 0.08, MAG_HI = 0.92, MAG_WAIT = 120, MAG_ANIM = 480;
var D = null, kind = mm('(max-width: 899px)') ? 'm' : 'd', fmt = 'webp', loading = false;
var base = [], inBase = [], stopImg = {}, stopIn = {}, atlasImg = {}, atlasIn = {}, frameImg = {}, frameIn = {};
var colour = { A: keyOf(cards.A), B: keyOf(cards.B) };
var near = false, pos = 0, vel = 0, target = 0, raf = 0, lastT = 0, drawn = -1, drawnKey = '', capOn = 0;
var magRaf = 0, magT = 0, userInput = 0, running = false, state = '';
function keyOf(card) { var b = card && $('.sw__b[aria-checked="true"]', card); return b ? b.getAttribute('data-key') : card ? card.getAttribute('data-key') || '' : ''; }
function still() { return HRC.motionMode === 'still'; }
function pad3(n) { return (n < 10 ? '00' : n < 100 ? '0' : '') + n; }
function where() {
var r = ride.getBoundingClientRect(), vh = (pin && pin.offsetHeight) || W.innerHeight || 1, span = Math.max(1, r.height - vh);
var a0 = span * HOLD_A / RUN, fl = span * FLIGHT / RUN, y = -r.top;
return { y: y, top: W.pageYOffset + r.top, span: span, a0: a0, fl: fl, q: Math.min(1, Math.max(0, (y - a0) / fl)), p: Math.min(1, Math.max(0, y / span)) };
}
function frameAt(q) {
if (!D) return 0;
var e = q + EASE * (q * q * (3 - 2 * q) - q), P = D.path, lo = 0, hi = P.length - 1;
if (e <= P[0]) return 0;
if (e >= P[hi]) return hi;
while (hi - lo > 1) { var mid = (lo + hi) >> 1; if (P[mid] <= e) lo = mid; else hi = mid; }
return lo + (P[hi] > P[lo] ? (e - P[lo]) / (P[hi] - P[lo]) : 0);
}
function spanOf(j) { return j <= D.spans.A[1] ? 'A' : j >= D.spans.B[0] ? 'B' : ''; }
function recOf(st, k) { var p = D.patches[colour[st]]; return p && p[kind].box[k]; }
function drawable(j) {
var k = D.store[j];
if (!inBase[k]) return false;
var st = spanOf(j);
if (!st) return true;
var r = recOf(st, k);
if (!r) return true;
return r[5] === 'stop' ? !!stopIn[colour[st] + kind] : r[5] === 'f' ? !!frameIn[colour[st] + kind + k] : !!atlasIn[colour[st] + kind];
}
function nearest(j) {
if (drawable(j)) return j;
for (var dd = 1; dd < D.n; dd++) {
if (j - dd >= 0 && drawable(j - dd)) return j - dd;
if (j + dd < D.n && drawable(j + dd)) return j + dd;
}
return -1;
}
function paint(slow) {
if (!D) return false;
var want = Math.min(D.n - 1, Math.max(0, Math.round(pos))), behind = false;
if (slow && drawn >= 0 && Math.abs(want - drawn) > 1) {
var step = drawn + (want > drawn ? 1 : -1);
if (drawable(step)) { want = step; behind = true; }
}
var j = nearest(want);
if (j < 0) return false;
var st = spanOf(j), key = st ? colour[st] : '';
if (j === drawn && key === drawnKey) return behind;
var k = D.store[j];
g.drawImage(base[k], 0, 0, cv.width, cv.height);
var r = st && recOf(st, k);
if (r) {
if (r[5] === 'stop') g.drawImage(stopImg[key + kind], r[0], r[1], r[2], r[3]);
else if (r[5] === 'f') g.drawImage(frameImg[key + kind + k], r[0], r[1], r[2], r[3]);
else g.drawImage(atlasImg[key + kind], r[5], r[6], r[7], r[8], r[0], r[1], r[2], r[3]);
}
drawn = j; drawnKey = key;
ride.setAttribute('data-frame', j);
if (!cv.classList.contains('on')) cv.classList.add('on');
return behind;
}
var frameDt = 1 / 60;
function tick(t) {
raf = 0;
var dt = lastT ? Math.min(0.05, (t - lastT) / 1000) : 1 / 60;
if (lastT) frameDt += (dt - frameDt) * 0.1;
lastT = t;
var x0 = pos - target, e = Math.exp(-OMEGA * dt), c = vel + OMEGA * x0;
pos = target + (x0 + c * dt) * e;
vel = (vel - OMEGA * c * dt) * e;
if (Math.abs(pos - target) < 0.02 && Math.abs(vel) < 0.05) { pos = target; vel = 0; }
var behind = paint(Math.abs(vel) * frameDt < 1);
if (pos !== target || vel || behind) raf = requestAnimationFrame(tick);
else lastT = 0;
}
function kick() { if (!raf && D && !still()) raf = requestAnimationFrame(tick); }
function frameFromScroll() {
var w = where();
target = frameAt(w.q);
if (prog) prog.parentNode.style.setProperty('--rp', w.p.toFixed(3));
var a = w.q < CAPS[1] ? 0 : w.q < CAPS[2] ? 1 : 2;
if (a !== capOn) { capOn = a; caps.forEach(function (c) { c.classList.toggle('on', +c.getAttribute('data-cap') === a); }); }
if (fline) { var k = w.q <= 0.2 || w.q >= 0.98 ? 0 : w.q < 0.85 ? 1 : 2; ride.classList.toggle('fl-in', k === 1); ride.classList.toggle('fl-out', k === 2); }
var s = w.q <= MAG_LO ? 'A' : w.q >= MAG_HI ? 'B' : 'FLIGHT';
if (s !== state) { state = s; ride.setAttribute('data-state', s); HRC.emit('ride', s); }
return w;
}
function onScroll() {
if (!near || still()) return;
var w = frameFromScroll();
kick();
clearTimeout(magT);
if (!running && w.q > MAG_LO && w.q < MAG_HI) magT = setTimeout(magnet, MAG_WAIT);
hint(w);
edgeHint(w);
}
var hintA = $('[data-ride-hint="a"]', ride), hintB = $('[data-ride-hint="b"]', ride), hintT = 0, seenA = false, doneB = false;
function hint(w) {
clearTimeout(hintT);
if (!hintA) return;
var atA = w.y >= -2 && w.q <= 0.001, atB = w.q >= 0.999 && w.y <= w.span + 2;
if (!atA) hintA.classList.remove('on');
if (hintB && !atB) hintB.classList.remove('on');
if (atA && !hintA.classList.contains('on')) hintT = setTimeout(function () { hintA.classList.add('on'); seenA = true; }, seenA ? 4000 : 600);
else if (atB && hintB && !doneB && !hintB.classList.contains('on')) hintT = setTimeout(function () { hintB.classList.add('on'); doneB = true; }, 600);
}
var edge = $('[data-ride-edge]', ride), edgeTx = $('[data-ride-edge-t]', ride), edgeT = 0, edgeAt = '', edgeSeen = false;
var nudgeT = 0, nudging = false, nudges = 0;
function placeEdge() {
var pr = pin.getBoundingClientRect(), head = $('[data-top]'), rail = $('.ride__prog', ride);
var lo = (head ? Math.max(0, head.getBoundingClientRect().bottom - pr.top) : 0) + 12;
var hi = (rail ? rail.getBoundingClientRect().top - pr.top - 9 : pin.offsetHeight) - 12;
var st = drawn >= 0 ? spanOf(drawn) : '', P = st && D.patches[colour[st]], r = P && (P[kind].pad || recOf(st, D.store[drawn]));
if (r) {
var cr = cv.getBoundingClientRect(), s = Math.max(cr.width / cv.width, cr.height / cv.height);
var px = cr.left - pr.left + (cr.width - cv.width * s) / 2, py = cr.top - pr.top + (cr.height - cv.height * s) / 2;
var below = Math.ceil(py + (r[1] + r[3]) * s) + 16;
if (px + (r[0] + r[2]) * s + 16 > edge.offsetLeft && hi - below >= edge.offsetHeight) lo = Math.max(lo, below);
}
edge.style.top = Math.round(Math.max(lo, (lo + hi) / 2 - edge.offsetHeight / 2)) + 'px';
}
if (edge) {
W.addEventListener('resize', function () { if (edgeAt) placeEdge(); });
if (W.ResizeObserver) new ResizeObserver(function () { if (edgeAt) placeEdge(); }).observe($('[data-ride-copy]', ride));
}
function showEdge(st) {
edgeT = 0;
var t = edge.getAttribute(st === 'B' ? 'data-b' : 'data-a');
if (edgeTx.textContent !== t) edgeTx.textContent = t;
placeEdge();
edge.classList.add('on'); edgeAt = st; edgeSeen = true;
}
function edgeHint(w) {
clearTimeout(edgeT); edgeT = 0;
if (!edge) return;
var atA = w.y >= -2 && w.q <= 0.001, atB = w.q >= 0.999 && w.y <= w.span + 2;
if (edgeAt === 'A' && !(w.y >= -2 && w.q <= 0.12)) { edge.classList.remove('on'); edgeAt = ''; }
if (edgeAt === 'B' && !atB) { edge.classList.remove('on'); edgeAt = ''; }
if (!edgeAt && (atA || atB)) edgeT = setTimeout(function () { showEdge(atA ? 'A' : 'B'); }, atA && !edgeSeen ? 600 : 3000);
clearTimeout(nudgeT);
if (atA && !nudging && HRC.ss.get('hrc.s.rideNudge') !== '1') nudgeT = setTimeout(nudge, 3000);
}
function nudge() {
if (!near || still() || !D || nudging) return;     // (test hook: the suites' contexts, like the door)
var w = where();
if (!(w.y >= -2 && w.q <= 0.001)) return;
HRC.ss.set('hrc.s.rideNudge', '1');
nudging = true; nudges++;
var t0 = 0, stamp = userInput, y0 = W.pageYOffset;
requestAnimationFrame(function step(ts) {
if (!t0) t0 = ts;
var k = Math.min(1, (ts - t0) / 900);
if (userInput !== stamp || W.pageYOffset !== y0 || still()) { nudging = false; frameFromScroll(); kick(); return; }
var s = Math.sin(Math.PI * k);
target = frameAt(Math.min(1, w.q + 0.06 * s * s * (3 - 2 * s)));
kick();
if (k < 1) requestAnimationFrame(step);
else { nudging = false; frameFromScroll(); kick(); }
});
}
function scrollTo(y, ms, done) {
cancelAnimationFrame(magRaf);
var from = W.pageYOffset, root = d.documentElement, prev = root.style.scrollBehavior, t0 = 0, stamp = userInput;
if (HRC.RM || Math.abs(y - from) < 2) { root.style.scrollBehavior = 'auto'; W.scrollTo(0, y); root.style.scrollBehavior = prev; if (done) done(); return; }
root.style.scrollBehavior = 'auto';
running = true;
magRaf = requestAnimationFrame(function stepTo(ts) {
if (userInput !== stamp) { running = false; root.style.scrollBehavior = prev; return; }   // the visitor took over
if (!t0) t0 = ts;
var k = Math.min(1, (ts - t0) / ms), e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
W.scrollTo(0, Math.round(from + (y - from) * e));
if (k < 1) magRaf = requestAnimationFrame(stepTo);
else { running = false; root.style.scrollBehavior = prev; if (done) done(); }
});
}
function stopY(st, w) { return Math.round(w.top + (st === 'A' ? w.a0 - 2 : w.a0 + w.fl + 2)); }
function magnet() {
if (!near || still()) return;
var w = where();
if (w.q <= MAG_LO || w.q >= MAG_HI) return;
var st = w.q < 0.5 ? 'A' : 'B', dq = st === 'A' ? w.q : 1 - w.q;
scrollTo(stopY(st, w), Math.min(MAG_ANIM, 200 + 560 * dq));
}
function runTo(st) { var w = where(); scrollTo(stopY(st, w), 760); }
['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) {
W.addEventListener(ev, function () { userInput++; clearTimeout(magT); }, { passive: true });
});
function img(src, done) {
var im = new Image();
im.decoding = 'async';
im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).then(function () { done(im); }, function () { done(im); }); };
im.src = src;
return im;
}
var pending = 0;
function queue(list, conc, counted) {
var i = 0, busy = 0;
if (!counted) pending += list.length;
function next() {
while (busy < conc && i < list.length) {
var job = list[i++];
busy++;
job(function () { busy--; pending--; next(); });
}
}
next();
}
function afterFirstScreen(fn) {
var idle = function () { if (W.requestIdleCallback) W.requestIdleCallback(fn, { timeout: 1200 }); else setTimeout(fn, 250); };
if (d.readyState === 'complete') idle(); else W.addEventListener('load', idle, { once: true });
}
function patchUrl(key, part) { var P = D.patches[key], p = P && P[kind][part]; return p ? p[fmt === 'avif' ? 'a' : 'w'] : null; }
function wantColour(key, withAtlas) {
var jobs = [], k = key + kind;
if (!D.patches[key]) return jobs;
if (!stopIn[k] && !stopImg[k] && patchUrl(key, 'stop')) jobs.push(function (cb) { if (stopImg[k]) return cb(); stopImg[k] = img(patchUrl(key, 'stop'), function () { stopIn[k] = true; paint(); cb(); }); });
var own = withAtlas ? D.patches[key][kind].frames || {} : {};
Object.keys(own).sort(function (a, b) { return a - b; }).forEach(function (j) {
var fk = k + j;
if (!frameImg[fk]) jobs.push(function (cb) { if (frameImg[fk]) return cb(); frameImg[fk] = img(own[j][fmt === 'avif' ? 'a' : 'w'], function () { frameIn[fk] = true; paint(); cb(); }); });
});
if (withAtlas && !atlasImg[k] && patchUrl(key, 'atlas')) jobs.push(function (cb) { if (atlasImg[k]) return cb(); atlasImg[k] = img(patchUrl(key, 'atlas'), function () { atlasIn[k] = true; paint(); cb(); }); });
return jobs;
}
function load() {
if (loading || still()) return;
loading = true;
if (kind === 'm') { cv.width = 720; cv.height = 1280; }
(function () { var el = document.getElementById('hrc-ride-data'); return el ? Promise.resolve(JSON.parse(el.textContent)) : Promise.reject(new Error('ride')); })().then(function (data) {
D = data;
var t = new Image();
t.decoding = 'async';
t.onload = function () { fmt = 'avif'; (t.decode ? t.decode() : Promise.resolve()).then(function () { go(t); }, function () { go(t); }); };
t.onerror = function () { fmt = 'webp'; go(null); };
t.src = D.f + kind + '-000.avif';
}, function () { loading = false; });
}
function go(first) {
var stored = [], seen = {};
D.store.forEach(function (k) { if (!seen[k]) { seen[k] = 1; stored.push(k); } });
var order = [], done = {};
if (first) { base[0] = first; inBase[0] = true; done[0] = 1; }
[[0, D.store[D.n - 1]], stored.filter(function (k, i) { return i % 4 === 0; }), stored].forEach(function (l) {
l.forEach(function (k) { if (!done[k]) { done[k] = 1; order.push(k); } });
});
var stops = [0, D.store[D.n - 1]], now = wantColour(colour.A, false).concat(wantColour(colour.B, false)), later = [];
order.forEach(function (k, i) {
(stops.indexOf(k) >= 0 ? now : later).push(function (cb) { base[k] = img(D.f + kind + '-' + pad3(k) + '.' + fmt, function () { inBase[k] = true; paint(); cb(); }); });
if (i === 6) later = later.concat(wantColour(colour.A, true), wantColour(colour.B, true));
});
Object.keys(D.patches).forEach(function (key) { if (key !== colour.A && key !== colour.B) later = later.concat(wantColour(key, false)); });
queue(now, 6);
pending += later.length;
afterFirstScreen(function () { queue(later, 6, true); });
frameFromScroll();
pos = target;
drawn = -1;
paint();
kick();
}
HRC.afterPaint(function () {
if ('IntersectionObserver' in W) {
new IntersectionObserver(function (es) {
near = es[0].isIntersecting;
if (near) { load(); onScroll(); }
}, { rootMargin: '150% 0px 150% 0px' }).observe(ride);
} else { near = true; load(); }
});
HRC.onScroll(onScroll);
HRC.on('motionmode', function () { if (!still()) { if (near) load(); drawn = -1; onScroll(); } });
['A', 'B'].forEach(function (st) {
var card = cards[st];
if (!card) return;
var pid = card.getAttribute('data-product');
$$('.sw__b', card).forEach(function (b) {
b.addEventListener('click', function () {
if (b.getAttribute('aria-checked') === 'true') return;
$$('.sw__b', card).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
card.setAttribute('data-variant', b.getAttribute('data-v'));
HRC.scentSwap($('[data-ride-scent]', card), function () {
$('[data-ride-vname]', card).textContent = b.getAttribute('data-name');
HRC.notesLine($('[data-ride-notes]', card), b.getAttribute('data-notes'));
var ln = $('[data-ride-line]', card); if (ln) ln.textContent = b.getAttribute('data-line');
});
var det = $('[data-ride-details]', card);
det.setAttribute('href', det.getAttribute('href').replace(/\?.*$/, '') + '?variant=' + b.getAttribute('data-vid'));
var band = $('[data-ride-band]', card);
if (band) band.src = b.getAttribute('data-still');
colour[st] = b.getAttribute('data-key');
if (D) { queue(wantColour(colour[st], true), 2); drawn = -1; paint(); }
if (D && !still()) {
var w = where();
if (st === 'A' ? w.q > MAG_LO : w.q < MAG_HI) runTo(st);
}
HRC.emit('variant-tried', { product: pid, variant: +b.getAttribute('data-v') });
HRC.track('select_item', { product: pid, variant: b.getAttribute('data-name'), source: 'ride' });
});
});
$('[data-ride-add]', card).addEventListener('click', function () {
HRC.bag.add(pid, +card.getAttribute('data-variant'), { source: 'ride' });
});
card.addEventListener('focusin', function () {
if (still() || card.classList.contains('on')) return;
var w = where(), root = d.documentElement, prev = root.style.scrollBehavior;
root.style.scrollBehavior = 'auto';
W.scrollTo(0, stopY(st, w));
root.style.scrollBehavior = prev;
frameFromScroll();
kick();
});
});
HRC.ride = { state: function () { return { frame: drawn, shown: D && drawn >= 0 ? D.store[drawn] : -1, key: drawnKey, pos: pos, target: target, n: D ? D.n : 0, loaded: inBase.filter(Boolean).length, pending: D ? pending : -1, colour: { A: colour.A, B: colour.B }, fmt: fmt, kind: kind, edge: edgeAt, nudges: nudges, nudging: nudging }; } };
})();
})();